import { Injectable } from '@angular/core';
import { InstrumentationParam, InstrumentationParams, InstrumentationService, KnownInstrumentationEvents } from '../../shared/instrumentation/instrumentation.service';
import { FileType } from '../../shared/models/file-item.model';
import { MruItemInflationService } from '../../shared/mru-item/mru-item-inflation.service';
import { MruConfigService } from '../../shared/mru/mru-config.service';

@Injectable({
    providedIn: 'root'
})
export class ThumbnailInstrumentationService {

    private readonly recordedThumbnails: Set<string>;

    constructor(
        private readonly instrumentationService: InstrumentationService,
        private readonly mruConfigService: MruConfigService
    ) {
        this.recordedThumbnails = new Set<string>();
    }

    public instrumentThumbnailLoad(success: boolean, url: string, listId: string, index: number, fileType: FileType) {
        if (!this.mruConfigService.config.logThumbnailLoadSuccess || this.recordedThumbnails.has(url) || !MruItemInflationService.thumbnailFileTypes.has(fileType)) {
            return;
        }

        const state = success ? 'Success' : 'Failed';
        const params = this.getInstrumentationParams(state, listId, index, fileType);
        this.instrumentationService.logGenericEvent(KnownInstrumentationEvents.ThumbnailLoad, params);
        this.recordedThumbnails.add(url);
    }

    private getInstrumentationParams(state: string, listId: string, index: number, fileType: FileType): InstrumentationParams {
        const params: InstrumentationParams = {};
        params[InstrumentationParam.State] = state;
        params[InstrumentationParam.ItemCategory] = listId;
        params[InstrumentationParam.Index] = index.toString();
        params[InstrumentationParam.DocumentType] = FileType[fileType];

        return params;
    }
}
